/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/Email";

//seting
export function getAll() {
  return APIClient.get(`${endpoint}`);
}

export function getAllRole() {
  return APIClient.get(`/Role`);
}

export function getOne() {
  return APIClient.get(`${endpoint}`);
}

export function remove(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}

export function create(value) {
  return APIClient.post(`${endpoint}`, value);
}

//static
export function getAllEmailStatic() {
  return APIClient.get(`${endpoint}Static`);
}

export function getOneEmailStatic() {
  return APIClient.get(`${endpoint}Static`);
}

export function removeEmailStatic(id) {
  return APIClient.delete(`${endpoint}Static/${id}`);
}

export function createEmailStatic(value) {
  let bodyFormData = new FormData();
  for (let key in value) {
    bodyFormData.append(key, value[key]);
  }
  return APIClient.post(`${endpoint}Static`, bodyFormData);
}

//templete
export function getAllEmailTemplete() {
  return APIClient.get(`${endpoint}Templete`);
}

export function getOneEmailTemplete() {
  return APIClient.get(`${endpoint}Templete`);
}

export function removeEmailTemplete(id) {
  return APIClient.delete(`${endpoint}Templete/${id}`);
}

export function createEmailTemplete(value) {
  return APIClient.post(`${endpoint}Templete`, value);
}

export function createEmailStatus(value) {
  return APIClient.post(`${endpoint}Status`, value);
}
